import { ViewProps } from "react-native";

export type WalletButtonProps = {
  onTap: () => void;
} & ViewProps;
